export enum ECredentialsProviderType {
  /**
   * 匿名用户
   */
  AnonymousUser = 'anonymous-user',
  /**
   * 系统用户（登录注册用户）
   */
  SystemUser = 'system-user',

  /**
   * Firebase集成登录
   */
  Firebase = 'firebase',
}
